export function readText() {
    return import('clipboard-polyfill').then((c) => c.readText());
}
export function read() {
    return import('clipboard-polyfill').then((c) => c.read());
}
export function writeText(data) {
    return import('clipboard-polyfill').then((c) => c.writeText(data));
}
export function write(data) {
    return import('clipboard-polyfill').then((c) => c.write(data));
}
export function newClipboardItem(items, options) {
    return import('clipboard-polyfill').then((c) => new c.ClipboardItem(items, options));
}
